import React from "react";
import TugPdfReport from "../../common/pdf/TugPdfReport";
const SideTugPdfReport = () => <TugPdfReport reportType="side" />;
export default SideTugPdfReport;
